import React from "react";
import { useSideBarContext } from "../context/sidebar_context";
import styled from "styled-components";
import { MdMenu, MdShoppingBag } from "react-icons/md";
import { Link } from "react-router-dom";
import { useCartContext } from "../context/cart_context";
import { useAuth0 } from "@auth0/auth0-react";

const Navbar = () => {
  const { total_items } = useCartContext();
  const { openSidebar } = useSideBarContext();
  const { user, isAuthenticated, isLoading, loginWithRedirect, logout } =
    useAuth0();

  if (isLoading) {
    return <div>Loading ...</div>;
  }

  return (
    <NavbarWrapper className="bg-white flex">
      <div className="container w-100">
        <div className="brand-and-toggler flex flex-between w-100">
          {/* logo */}
          <Link to="/" className="navbar-brand text-uppercase ls-1 fw-8">
            Intellif<span>ai</span>
          </Link>
          <div className="navbar-btns flex">
            {isAuthenticated ? (
              <>
                <span>{user["email"]}</span>
                <span
                  className="navbar-buton login-btn"
                  onClick={() =>
                    logout({
                      logoutParams: { returnTo: window.location.origin },
                    })
                  }
                >
                  Logout
                </span>
              </>
            ) : (
              <>
                <span
                  className="navbar-buton login-btn"
                  onClick={() => loginWithRedirect()}
                >
                  Log In
                </span>
              </>
            )}
            <button
              type="button"
              className="sidebar-open-btn"
              onClick={() => openSidebar()}
            >
              <MdMenu />
            </button>
          </div>
        </div>
      </div>
    </NavbarWrapper>
  );
};
const NavbarWrapper = styled.nav`
  height: 80px;
  box-shadow: rgba(50, 50, 93, 0.15) 0px 16px 12px -2px,
    rgba(0, 0, 0, 0.2) 0px 3px 7px -3px;

  .navbar-brand {
    font-size: 23px;
    span {
      color: var(--clr-red);
      font-family: var(--additional-font);
      font-size: 30px;
    }
  }

  .navbar-buton {
    cursor: pointer;
    margin-right: 1em;
    margin-left: 1em;
    font-size: 1em;
    padding: 0.3em 0.5em;
    transition: all 0.2s;
    &:hover {
      scale: 1.1;
    }
  }

  .login-btn {
    background: #ed4136;
    color: #fefefe;
  }

  .signup-btn {
    border: 1px solid #ed4136;
  }

  .cart-btn {
    margin-right: 18px;
    font-size: 23px;
    position: relative;

    .item-count-badge {
      position: absolute;
      right: -10px;
      top: -10px;
      background-color: var(--clr-red);
      font-size: 11px;
      font-weight: 700;
      display: block;
      width: 22px;
      height: 22px;
      color: var(--clr-white);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .sidebar-open-btn {
    transition: all 300ms ease-in-out;
    &:hover {
      opacity: 0.7;
    }
  }
`;
export default Navbar;
